import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import toast from "react-hot-toast";
import { IoReload } from "react-icons/io5";
import { FaCheck, FaCheckCircle, FaChevronDown, FaLongArrowAltDown, FaLongArrowAltUp } from "react-icons/fa";
import { IoIosClose } from "react-icons/io";
import Top from "../components/Top";
import Navbar from "../components/Navbar";
import { useNavigate } from "react-router-dom";
import { SlCalender } from "react-icons/sl";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { formatAiScore } from "../utils/aiReport";

const canSendAssessment = (candidate, activeJobs) =>
  candidate.ai_scoring_status === "succeeded" &&
  candidate.status === "qualified" &&
  candidate.assessment_score === null &&
  activeJobs.includes(candidate.job_code) &&
  candidate.hr_status !== "fail" &&
  Number(candidate?.ai_report?.percentage) > 0;

const candidateScoreLabel = (candidate) => {
  if (candidate.ai_scoring_status === "pending" || candidate.ai_scoring_status === "processing") return "Pending";
  if (candidate.ai_scoring_status === "retrying") return "Retry scheduled";
  if (candidate.ai_scoring_status === "failed") return "Scoring failed";
  return formatAiScore(candidate.ai_report);
};

const RecruiterDashboard = ({ currentUser }) => {
  const [candidates, setCandidates] = useState([]);
  const [candidates2, setCandidates2] = useState([]);
  const [filteredCandidates, setFilteredCandidates] = useState([]);
  const [filteredCandidates2, setFilteredCandidates2] = useState([]);
  const [loading, setLoading] = useState(true);
  const [jobLoading, setJobLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(true);
  const [jobs, setJobs] = useState([]);
  const [count, setCount] = useState(0);
  const [loadingMap, setLoadingMap] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [loadingA, setLoadingA] = useState(false);
  const [loadingC, setLoadingC] = useState(false);
  const [jobTitle, setJobTitle] = useState("");
  const [jobCode, setJobCode] = useState("");
  const [jobStatus, setJobStatus] = useState("");
  const [jobType, setJobType] = useState("active");
  const [emailStatus, setEmailStatus] = useState("");
  const [assessmentStatus, setAssessmentStatus] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [aiReport, setAiReport] = useState({});
  const [aiJobTitle, setAiJobTitle] = useState("");
  const [showReport, setShowReport] = useState(false);
  const [selectedCandidateId, setSelectedCandidateId] = useState(null);
  const [retryingAiScore, setRetryingAiScore] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [emailArray, setEmailArray] = useState([]);
  const [inactive, setInactive] = useState(0);
  const [allOptions, setAllOptions] = useState([]);
  const [finalOptions, setFinalOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [showJobSelect, setShowJobSelect] = useState(false);
  const [batchStatus, setBatchStatus] = useState(false);
  const batchStatusRef = useRef(false);
  const [batchTime, setBatchTime] = useState("");
  const [syncStatus, setSyncStatus] = useState(null);
  const [sortOrder, setSortOrder] = useState("desc")
  const [sortOn, setSortOn] = useState(false)
  const [checkedCandidates, setCheckedCandidates] = useState([])
  const [allChecked, setAllChecked] = useState(false)
  const [showConfirmationBox, setShowConfirmationBox] = useState(false)

  const navigate = useNavigate()

  const totalPages = Math.ceil(count / itemsPerPage);
  const today = new Date().toISOString().split("T")[0];

  const fromDateRef = useRef()
  const toDateRef = useRef()
  const jobTitleSRef = useRef()
  const jobToggleRef = useRef()
  const optionRef1 = useRef()
  const selectedJobRef = useRef()

  const activeJobsArr = jobs.map((job) => job.job_code)

  const selectRef1 = useRef(null);
  const selectRef2 = useRef(null);
  const selectRef3 = useRef(null);
  const selectRef4 = useRef(null);
  const selectRef5 = useRef(null);
  const selectRef6 = useRef(null);

  const handleFromDateClick = () => {
    fromDateRef.current.showPicker()
  }

  const handleToDateClick = () => {
    toDateRef.current.showPicker()
  }

  useEffect(() => {
    let pollInterval;

    const pollBatchStatus = async () => {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/api/v1/batch_status`,
          { withCredentials: true }
        );
        const status = response.data.batch_status;
        const isRunning = Boolean(status.running);
        const wasRunning = batchStatusRef.current;

        batchStatusRef.current = isRunning;
        setBatchStatus(isRunning);
        setBatchTime(status.state?.last_successful_sync_at || status.last_update);
        setSyncStatus(status);

        // If batch just finished, refresh candidates
        if (!isRunning && wasRunning) {
          console.log("Batch completed, refreshing candidates...");
          setInactive((prev) => prev + 1);
          if (status.run?.status === "succeeded") {
            toast.success("CEIPAL synchronization completed!");
          } else {
            toast.error(status.run?.error_summary || "CEIPAL synchronization failed");
          }
        }

        // If batch just started by another user
        if (isRunning && !wasRunning) {
          toast.info("Batch processing started");
        }
      } catch (error) {
        console.error("Failed to poll batch status:", error);
      }
    };

    // Poll every 5 seconds - good balance between responsiveness and server load
    pollInterval = setInterval(pollBatchStatus, 5000);

    // Cleanup on unmount
    return () => {
      if (pollInterval) {
        clearInterval(pollInterval);
      }
    };
  }, []); // Empty dependency - runs once, polls continuously

  useEffect(() => {
    if (selectedJobRef.current) {
      selectedJobRef.current.scrollIntoView()
    }
  }, [showJobSelect])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showJobSelect && jobTitleSRef.current && !jobTitleSRef.current.contains(event.target) &&
        jobToggleRef.current &&
        !jobToggleRef.current.contains(event.target)) {
        setShowJobSelect(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [showJobSelect])

  useEffect(() => {
    const fetchCandidates = async () => {
      setTableLoading(true);
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
          }/api/v1/get-submissions`,
          {
            withCredentials: true
          }
        );
        setCount(response.data.submission_count);
        setFilteredCandidates(response.data.candidates.slice(0, itemsPerPage));
        setCandidates(response.data.candidates);
        setCandidates2(response.data.candidates);
        setTableLoading(false);
      } catch (error) {
        setTableLoading(false);
      }
    };
    fetchCandidates();
  }, [inactive]);

  useEffect(() => {
    const fetchBatchStatus = async () => {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
          }/api/v1/batch_status`,
          {
            withCredentials: true
          }
        );
        const status = response.data.batch_status;
        setBatchStatus(Boolean(status.running))
        setBatchTime(status.state?.last_successful_sync_at || status.last_update)
        setSyncStatus(status)
        setLoading3(false)
      } catch (error) {
        setLoading3(false)
        toast.error("Failed to get batch status.")
      }
    };
    fetchBatchStatus();
  }, []);

  useEffect(() => {
    if (jobs && candidates) {
      // Create a Map to track unique job codes
      const uniqueJobsMap = new Map();

      // Create a Set of job codes from candidates for quick lookup
      const candidateJobCodes = new Set();
      candidates.forEach((candidate) => {
        if (candidate.job_code) {
          candidateJobCodes.add(candidate.job_code);
        }
      });

      // First, add all jobs from jobs array
      jobs.forEach((job) => {
        if (job.job_code) {
          uniqueJobsMap.set(job.job_code, {
            jobTitle: job.job_title,
            jobCode: job.job_code
          });
        }
      });

      // Then, override with candidate data only if the job_code exists in jobs
      candidates.forEach((candidate) => {
        if (candidate.job_code && uniqueJobsMap.has(candidate.job_code)) {
          uniqueJobsMap.set(candidate.job_code, {
            jobTitle: candidate.job_title,
            jobCode: candidate.job_code
          });
        }
      });

      // Convert Map values to array for finalOptions
      const combinedOptions = Array.from(uniqueJobsMap.values());
      setFinalOptions(combinedOptions);
      setAllOptions(combinedOptions);
    }
  }, [jobs, candidates]);

  useEffect(() => {
    let inactivityTimer;
    const INACTIVITY_TIMEOUT = 60000;

    const resetInactivityTimer = () => {
      clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(() => {
        setInactive((prev) => prev + 1)
        handleReset()
      }, INACTIVITY_TIMEOUT);
    };

    const activityEvents = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];

    activityEvents.forEach(event => {
      window.addEventListener(event, resetInactivityTimer);
    });

    resetInactivityTimer();

    return () => {
      clearTimeout(inactivityTimer);
      activityEvents.forEach(event => {
        window.removeEventListener(event, resetInactivityTimer);
      });
    };
  }, [candidates]);

  useEffect(() => {
    if (candidates.length > 0) {
      setSearchValue(searchValue || localStorage.getItem("searchValue1"))
      setJobTitle(jobTitle || localStorage.getItem("jobTitlevalue1"))
      setJobCode(jobCode || localStorage.getItem("jobCodeValue1"))
      setJobType(jobType || localStorage.getItem("jobTypeValue1"))
      setJobStatus(jobStatus || localStorage.getItem("jobStatusValue1"))
      setEmailStatus(emailStatus || localStorage.getItem("emailStatusValue1"))
      setAssessmentStatus(assessmentStatus || localStorage.getItem("assessmentStatusValue1"))
      setFromDate(fromDate || localStorage.getItem("fromDateValue1"))
      setToDate(toDate || localStorage.getItem("toDateValue1"))
      applyFilters(searchValue, jobTitle || localStorage.getItem("jobTitlevalue1"), jobCode || localStorage.getItem("jobCodeValue1"), jobStatus || localStorage.getItem("jobStatusValue1"), emailStatus || localStorage.getItem("emailStatusValue1"), assessmentStatus || localStorage.getItem("assessmentStatusValue1"), fromDate || localStorage.getItem("fromDateValue1"), toDate || localStorage.getItem("toDateValue1"), localStorage.getItem("jobTypeValue1") || "active")
    }
  }, [jobs, candidates])

  useEffect(() => {
    setCurrentPage(1); // Reset to first page
    const startIndex = currentPage - 1;
    const endIndex = startIndex + itemsPerPage;

    const isSearchEmpty = !searchValue && !jobCode && !jobTitle && !jobStatus && !emailStatus && !assessmentStatus && !fromDate && !toDate && !jobType;

    if (filteredCandidates2.length > 0) {
      setFilteredCandidates(filteredCandidates2.slice(startIndex, endIndex));
    } else if (filteredCandidates2.length <= 1 && isSearchEmpty) {
      setFilteredCandidates(candidates.slice(startIndex, endIndex));
    } else {
      setFilteredCandidates([]);
    }
  }, [filteredCandidates2, itemsPerPage]);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
          }/api/v1/get-all-jobs`,
          {
            withCredentials: true
          }
        );
        const data = response.data.jobs;
        setJobs(data);
      } catch (err) {
        toast.error("Failed to load candidated.")
      } finally {
        setLoading(false);
      }
    };

    fetchJobs();
  }, []);

  const applyFilters = (searchValue, jobTitle, jobCode, jobStatus, emailStatus, assessmentStatus, fromDate, toDate, jobType) => {
    setTableLoading(true);

    let filtered = [...candidates];

    if (jobTitle) {
      filtered = filtered.filter(candidate => candidate.job_title === jobTitle);
    }

    if (jobCode) {
      filtered = filtered.filter(candidate => candidate.job_code === jobCode);
    }

    if (jobStatus) {
      filtered = filtered.filter(candidate => candidate.status === jobStatus);
    }

    if (jobType && jobs.length > 0) {
      const activeJobsArray = jobs.map((job) => job.job_code)
      if (jobType === "active") {

        filtered = filtered.filter(candidate => activeJobsArray.includes(candidate.job_code));
      } else {
        filtered = filtered.filter(candidate => !activeJobsArray.includes(candidate.job_code));
      }
    }

    if (emailStatus) {
      if (emailStatus === "not-sent") {
        filtered = filtered.filter(candidate => candidate.email_status === "not-sent" || candidate.email_status === null);
      } else {
        filtered = filtered.filter(candidate => candidate.email_status === "sent");
      }
    }

    if (fromDate && toDate) {
      const from = new Date(`${fromDate}T00:00:00`);
      const to = new Date(`${toDate}T23:59:59.999`);

      filtered = filtered.filter(candidate => {
        if (!candidate.sent_time) return false;

        const candidateDate = new Date(candidate.sent_time.replace(' ', 'T')); // ✅ Fix here
        return candidateDate >= from && candidateDate <= to;
      });

    }

    if (assessmentStatus) {
      if (assessmentStatus === "assessed") {
        filtered = filtered.filter(candidate => candidate.assessment_score !== null);
      } else if (assessmentStatus === "not-assessed") {
        filtered = filtered.filter(candidate => candidate.assessment_score === null && candidate.hr_status === null);
      } else if (assessmentStatus === "hr-assessed") {
        filtered = filtered.filter(candidate => candidate.hr_status !== null && candidate.assessment_score === null);
      }
    }

    if (searchValue) {
      const normalizedSearch = String(searchValue).replace(/[^a-zA-Z0-9]/g, '').toLowerCase();


      filtered = filtered.filter((candidate) => {
        const normalizedName = String(candidate.name || '').replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
        const normalizedEmail = String(candidate.email || '').replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
        const normalizedApplicantId = String(candidate.applicant_id || '').replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
        const normalizedPhoneNo = String(candidate.phone_no || '').replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
        const normalizedJobCode = String(candidate.job_code || '').replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
        const normalizedJobTitle = String(candidate.job_title || '').replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
        const normalizedClientName = String(candidate.client_name || '').replace(/[^a-zA-Z0-9]/g, '').toLowerCase();

        if (normalizedSearch === normalizedApplicantId) {
          return true;
        }

        if (normalizedSearch.match(/^\d+$/) && normalizedApplicantId.includes(normalizedSearch)) {
          return true;
        }

        const matches =
          normalizedName.includes(normalizedSearch) ||
          normalizedEmail.includes(normalizedSearch) ||
          normalizedJobCode.includes(normalizedSearch) ||
          normalizedJobTitle.includes(normalizedSearch) ||
          normalizedClientName.includes(normalizedSearch) ||
          normalizedPhoneNo.includes(normalizedSearch);

        return matches;
      });
    }

    setFilteredCandidates2(filtered);
    setCurrentPage(1);
    setCount(filtered.length);
    setTableLoading(false);
  };

  const handleJobTitleChange = (value) => {
    setInputValue("")
    setFinalOptions(allOptions)
    // setOptions(allOptions)
    setShowJobSelect(false)
    setJobTitle(value);
    localStorage.setItem("jobTitlevalue1", value)
    applyFilters(searchValue, value, "", jobStatus, emailStatus, assessmentStatus, fromDate, toDate, jobType)
  };

  const handleJobTitleChange1 = (value) => {
    setInputValue("")
    setFinalOptions(allOptions)
    // setOptions(allOptions)
    setJobTitle(value);
    applyFilters(searchValue, value, jobCode, jobStatus, emailStatus, assessmentStatus, fromDate, toDate, jobType)
  };

  const handleJobCodeChange = (event) => {
    if (event.target.value.length < 1) {
      setFinalOptions(allOptions)
    }
    localStorage.setItem("jobCodeValue1", event.target.value)
    setJobCode(event.target.value);
    applyFilters(searchValue, jobTitle, event.target.value, jobStatus, emailStatus, assessmentStatus, fromDate, toDate, jobType)
  };

  const handleJobStatusChange = (event) => {
    setJobStatus(event.target.value);
    localStorage.setItem("jobStatusValue1", event.target.value)
    applyFilters(searchValue, jobTitle, jobCode, event.target.value, emailStatus, assessmentStatus, fromDate, toDate, jobType)
  };

  const handleJobTypeChange = (event) => {
    setJobType(event.target.value);
    localStorage.setItem("jobTypeValue1", event.target.value)
    applyFilters(searchValue, jobTitle, jobCode, jobStatus, emailStatus, assessmentStatus, fromDate, toDate, event.target.value)
  };

  const handleEmailStatusChange = (event) => {
    setEmailStatus(event.target.value);
    localStorage.setItem("emailStatusValue1", event.target.value)
    applyFilters(searchValue, jobTitle, jobCode, jobStatus, event.target.value, assessmentStatus, fromDate, toDate, jobType)
  };

  const handleAssessmentStatusChange = (event) => {
    setAssessmentStatus(event.target.value);
    localStorage.setItem("assessmentStatusValue1", event.target.value)
    applyFilters(searchValue, jobTitle, jobCode, jobStatus, emailStatus, event.target.value, fromDate, toDate, jobType)
  };

  const handleFromDate = (event) => {
    setFromDate(event.target.value);
    localStorage.setItem("fromDateValue1", event.target.value)
    applyFilters(searchValue, jobTitle, jobCode, jobStatus, emailStatus, assessmentStatus, event.target.value, toDate, jobType)
  }

  const handleToDate = (event) => {
    setToDate(event.target.value);
    localStorage.setItem("toDateValue1", event.target.value)
    applyFilters(searchValue, jobTitle, jobCode, jobStatus, emailStatus, assessmentStatus, fromDate, event.target.value, jobType)
  }

  const handleSearch = (e) => {
    const value = e.target.value;
    const filteredValue = value.replace(/[^a-zA-Z0-9@._\- ]/g, '');

    setSearchValue(filteredValue);
    applyFilters(filteredValue, jobTitle, jobCode, jobStatus, emailStatus, assessmentStatus, fromDate, toDate, jobType);
  };

  const handleSearch2 = (value) => {
    const filteredValue = value.replace(/[^a-zA-Z0-9@._\- ]/g, '');

    setSearchValue(filteredValue);
    applyFilters(filteredValue, jobTitle, jobCode, jobStatus, emailStatus, assessmentStatus, fromDate, toDate, jobType);
  };

  const sendSingleMail = async (name, applicantId, candidateId, email, phoneNo) => {
    setLoadingMap((prev) => ({ ...prev, [candidateId]: true }));

    try {
      const response = await axios.post(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/api/v1/send-email`,
        { name, applicantId, candidateId, email, phoneNo },
        {
          withCredentials: true
        }
      );
      if (response.data.success) {
        setEmailArray((prev) => [...prev, candidateId])
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setLoadingMap((prev) => ({ ...prev, [candidateId]: false }));
    }
  };

  const handleSendLinks = async () => {
    if (checkedCandidates.length > 0) {
      const viableCandidates = checkedCandidates.filter((candidate) =>
        canSendAssessment(candidate, activeJobsArr)
      );
      if (viableCandidates.length > 0) {
        setLoadingC((prev) => !prev);
        try {
          const responses = await Promise.all(
            viableCandidates.map(async (candidate) => {
              try {
                const response = await axios.post(
                  `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
                  }/api/v1/send-email`,
                  {
                    name: candidate.name,
                    applicantId: candidate.applicant_id,
                    candidateId: candidate.candidate_id,
                    email: candidate.email,
                    phoneNo: candidate.phone_no,
                  },
                  {
                    withCredentials: true
                  }
                );

                if (response.data.success) {
                  return { success: true };
                } else {
                  return { success: false, message: response.data.message };
                }
              } catch (error) {
                return { success: false, message: error.response.data.message };
              }
            })
          );

          const failedResponses = responses.filter(res => !res.success);

          const failedSMSCount = failedResponses.filter(res => res.message === "Failed to send SMS").length;
          const failedEmailCount = failedResponses.length - failedSMSCount;

          if (failedResponses.length === 0) {
            toast.success("All notifications sent successfully!");
          } else {
            if (failedSMSCount > 0) {
              toast.error(`Failed to send ${failedSMSCount} SMS messages.`);
            }
            if (failedEmailCount > 0) {
              toast.error(`Failed to send ${failedEmailCount} emails.`);
            }
          }

        } catch (error) {
          toast.error("Something went wrong while sending emails.");
        } finally {
          setCheckedCandidates([])
          setAllChecked(false)
          setLoadingC((prev) => !prev);
        }
      }
    } else {
      const qualifiedCandidates = filteredCandidates.filter(
        (candidate) => canSendAssessment(candidate, activeJobsArr)
      );
      qualifiedCandidates.forEach((qCan) => {
        setEmailArray((prev) => [...prev, qCan.candidate_id])
      })
      if (qualifiedCandidates.length > 0) {
        setLoadingA((prev) => !prev);
        try {
          const responses = await Promise.all(
            qualifiedCandidates.map(async (candidate) => {
              try {
                const response = await axios.post(
                  `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
                  }/api/v1/send-email`,
                  {
                    name: candidate.name,
                    applicantId: candidate.applicant_id,
                    candidateId: candidate.candidate_id,
                    email: candidate.email,
                    phoneNo: candidate.phone_no,
                  },
                  {
                    withCredentials: true
                  }
                );

                if (response.data.success) {
                  return { success: true };
                } else {
                  return { success: false, message: response.data.message };
                }
              } catch (error) {
                return { success: false, message: "Request failed" };
              }
            })
          );

          const failedEmails = responses.filter((res) => !res.success);

          if (failedEmails.length === 0) {
            toast.success("All emails sent successfully!");
          } else {
            toast.error(`Failed to send ${failedEmails.length} emails.`);
          }
        } catch (error) {
          toast.error("Something went wrong while sending emails.");
        } finally {
          setLoadingA((prev) => !prev);
        }
      }
    }
  };

  const setTableLoading = (val) => {
    setLoading2(val);
  };

  const handleJobPostings = async () => {
    if (batchStatus) {
      toast.error("Batch already running");
      return;
    }

    try {
      setJobLoading(true);
      batchStatusRef.current = true;
      setBatchStatus(true);

      const response = await axios.post(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/api/v1/run-batch`,
        {},
        { withCredentials: true }
      );

      if (response.data.success) {
        if (response.status === 200 && Array.isArray(response.data.candidates)) {
          batchStatusRef.current = false;
          setBatchStatus(false);
          setCount(response.data.submission_count);
          setFilteredCandidates(response.data.candidates.slice(0, itemsPerPage));
          setCandidates(response.data.candidates);
          toast.success("Candidates Refreshed");
        } else {
          toast.success("Candidate refresh started");
        }
      } else if (response.data.message === "Batch already running") {
        toast.error("Batch already running");
      }
    } catch (error) {
      if (error.response?.data?.message === "Batch already running") {
        toast.error("Batch already running");
        setBatchStatus(true);
      } else {
        toast.error("An error occurred while refreshing the Candidates");
        batchStatusRef.current = false;
        setBatchStatus(false); // Reset on error
      }
    } finally {
      setJobLoading(false);
    }
  };

  const handlePageChange = async (num) => {
    setLoading2((prev) => !prev);
    setCurrentPage(num);

    function getItemsForPage(arr, pageNum) {
      const startIndex = (pageNum - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      return arr.slice(startIndex, endIndex);
    }

    let paginatedCandidates
    if (filteredCandidates2.length > 1) {
      paginatedCandidates = getItemsForPage(filteredCandidates2, num);
    } else {
      paginatedCandidates = getItemsForPage(candidates, num);
    }

    setFilteredCandidates(paginatedCandidates);

    setLoading2((prev) => !prev);
  };

  const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1);

      if (currentPage > 3) pages.push("...");

      const start = Math.max(2, currentPage - 1);
      const end = Math.min(totalPages - 1, currentPage + 1);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (currentPage < totalPages - 2) pages.push("...");

      pages.push(totalPages);
    }

    return pages;
  };

  const handleReport = (report, jobTitle, candidateId) => {
    setAiReport(
      report || {
        success: false,
        error: "No AI report is available.",
        parameters: [],
        percentage: 0,
      }
    );
    setAiJobTitle(jobTitle);
    setSelectedCandidateId(candidateId);
    setShowReport(true);
  };

  const closeReport = () => {
    if (!retryingAiScore) {
      setShowReport(false);
    }
  };

  const retryAiScore = async () => {
    if (!selectedCandidateId || retryingAiScore) return;

    const confirmed = window.confirm(
      "Retrying will send this candidate's resume and job description to Google Gemini for scoring. Continue?"
    );
    if (!confirmed) return;

    setRetryingAiScore(true);
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/api/v1/retry-ai-score`,
        { candidateId: selectedCandidateId },
        { withCredentials: true }
      );

      setAiReport(response.data.ai_report);
      setInactive((value) => value + 1);
      toast.success(response.data.message || "AI score updated.");
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to retry AI score."
      );
    } finally {
      setRetryingAiScore(false);
    }
  };

  // if (loading) {
  //   return (
  //     <div className="flex justify-center items-center h-screen">
  //       <ClipLoader />
  //     </div>
  //   );
  // }


  const handleNavigate = (candidateId, flag) => {
    if (flag) {
      navigate(`/candidate-progress-page/${candidateId}`)
    } else {
      navigate(`/candidate-hr-progress/${candidateId}`)
    }
  }

  const sortScores = () => {
    const sortedCandidates = [...filteredCandidates].sort((a, b) => {
      // Handle cases where ai_report or percentage might be missing
      const scoreA = Number(a?.ai_report?.percentage) || 0;
      const scoreB = Number(b?.ai_report?.percentage) || 0;
      // Sort in descending order (higher scores first)
      return sortOrder === "desc" ? scoreB - scoreA : scoreA - scoreB;
    });
    setFilteredCandidates(sortedCandidates);
    const sortedCandidates2 = [...filteredCandidates2].sort((a, b) => {
      // Handle cases where ai_report or percentage might be missing
      const scoreA = Number(a?.ai_report?.percentage) || 0;
      const scoreB = Number(b?.ai_report?.percentage) || 0;
      // Sort in descending order (higher scores first)
      return sortOrder === "desc" ? scoreB - scoreA : scoreA - scoreB;
    });
    setFilteredCandidates2(sortedCandidates2);
    const sortedCandidates3 = [...candidates].sort((a, b) => {
      // Handle cases where ai_report or percentage might be missing
      const scoreA = Number(a?.ai_report?.percentage) || 0;
      const scoreB = Number(b?.ai_report?.percentage) || 0;
      // Sort in descending order (higher scores first)
      return sortOrder === "desc" ? scoreB - scoreA : scoreA - scoreB;
    });
    setCandidates(sortedCandidates3);

    setSortOrder(sortOrder === "desc" ? "asc" : "desc")
    setSortOn(true)
  };

  const sortName = () => {
    const sortedCandidates = [...filteredCandidates].sort((a, b) => {
      const nameA = a?.name?.toLowerCase()?.trim();
      const nameB = b?.name?.toLowerCase()?.trim();

      // Put records without names at the end
      if ((!nameA || nameA === '') && (!nameB || nameB === '')) return 0;
      if (!nameA || nameA === '') return 1;  // a goes after b
      if (!nameB || nameB === '') return -1; // a goes before b

      return nameA.localeCompare(nameB);
    });
    setFilteredCandidates(sortedCandidates);

    const sortedCandidates2 = [...filteredCandidates2].sort((a, b) => {
      const nameA = a?.name?.toLowerCase()?.trim();
      const nameB = b?.name?.toLowerCase()?.trim();

      // Put records without names at the end
      if ((!nameA || nameA === '') && (!nameB || nameB === '')) return 0;
      if (!nameA || nameA === '') return 1;  // a goes after b
      if (!nameB || nameB === '') return -1; // a goes before b

      return nameA.localeCompare(nameB);
    });
    setFilteredCandidates2(sortedCandidates2);

    const sortedCandidates3 = [...candidates].sort((a, b) => {
      const nameA = a?.name?.toLowerCase()?.trim();
      const nameB = b?.name?.toLowerCase()?.trim();

      // Put records without names at the end
      if ((!nameA || nameA === '') && (!nameB || nameB === '')) return 0;
      if (!nameA || nameA === '') return 1;  // a goes after b
      if (!nameB || nameB === '') return -1; // a goes before b

      return nameA.localeCompare(nameB);
    });
    setCandidates(sortedCandidates3);
  };

  const handleReset = () => {
    sortName()
    setSortOn(false)
    setSortOrder("desc")
    setJobCode("")
    setJobTitle("")
    setJobType("active")
    setJobStatus("")
    setEmailStatus("")
    setAssessmentStatus("")
    setFromDate("")
    setToDate("")
    setSearchValue("")
    setCheckedCandidates([])
    setAllChecked(false)

    localStorage.setItem("searchValue1", "")
    localStorage.setItem("jobTitlevalue1", "")
    localStorage.setItem("jobCodeValue1", "")
    localStorage.setItem("jobTypeValue1", "")
    localStorage.setItem("jobStatusValue1", "")
    localStorage.setItem("emailStatusValue1", "")
    localStorage.setItem("assessmentStatusValue1", "")
    localStorage.setItem("fromDateValue1", "")
    localStorage.setItem("toDateValue1", "")

    if (selectRef1.current) selectRef1.current.selectedIndex = 0;
    if (selectRef2.current) selectRef2.current.selectedIndex = 0;
    if (selectRef3.current) selectRef3.current.selectedIndex = 1;
    if (selectRef4.current) selectRef4.current.selectedIndex = 0;
    if (selectRef5.current) selectRef5.current.selectedIndex = 0;
    if (selectRef6.current) selectRef6.current.selectedIndex = 0;
    if (fromDateRef.current) fromDateRef.current.value = '';
    if (toDateRef.current) toDateRef.current.value = '';

    applyFilters("", "", "", "", "", "", "", "", "active")
  };

  const handleItemPerPage = (number) => {
    setItemsPerPage(number)
  }

  const handelJobTitleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setInputValue(value);

    const filtered = allOptions.filter(job =>
      job.jobTitle.toLowerCase().includes(value)
    );

    setFinalOptions(filtered);
  };

  const handleCheck = (candidate, index) => {
    setCheckedCandidates((prev) => {
      let previous = [...prev]
      let alreadyChecked = checkedCandidates.find((can) => can?.candidate_id === candidate?.candidate_id)
      if (!alreadyChecked) {
        previous.push(candidate)
      } else {
        return previous.filter((prev) => prev.candidate_id !== candidate.candidate_id)
      }
      return previous
    })
  }

  const handleAllCheck = () => {
    setAllChecked((prev) => !prev)
    setCheckedCandidates(allChecked ? [] : filteredCandidates)
  }

  const handleConfirmSend = async () => {
    try {
      setShowConfirmationBox(false)
      handleSendLinks()
    } catch (error) {
      setShowConfirmationBox(false)
      toast.error("Failed to send links.");
    }
  };

  const handleConfirmSendBox = (email) => {
    setShowConfirmationBox((prev) => !prev)
  }


  return (
    <div>
      <div
        className={`w-screen h-screen bg-[#0A0813E3] flex items-center justify-center fixed z-[99] top-0 left-0 transition-opacity duration-200 ${!showConfirmationBox
          ? "opacity-0 scale-95 pointer-events-none"
          : "opacity-100 scale-100"
          }`}
      >
        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby="send-assessments-title"
          className={`bg-white absolute rounded-[24px] shadow-md p-8 w-[311px] h-[353px] sm:h-[260px] sm:w-[360px] xl:h-[260px] xl:w-[403px] flex flex-col gap-4 items-center justify-center text-center sm:p-9 xl:p-10 sm:gap-4 xl:gap-4 transition-transform duration-400`}
        >
          <img src="/images/error.png" className="w-[36px]" alt="" />
          <h2 id="send-assessments-title" className="font-bold text-[20px] leading-[122%] tracking-[0%] text-center sm:text-[18px] xl:text-[20px] 2xl:text-[22px] xxl:text-2xl sm:leading-none xl:leading-none text-[#5D0E23] sm:tracking-normal xl:tracking-normal">
            Are you sure you want to send links.
          </h2>
          <div className="flex gap-2">
            <button
              type="button"
              onClick={handleConfirmSend}
              className="mt-4 bg-[#5D0E23] hover:bg-[#55051A] font-semibold sm:text-[11px] xl:text-[12px] 2xl:text-[13px] xxl:text-[14px] leading-none tracking-[-0.04em] text-center  cursor-pointer translate-all duration-400 text-white py-3 px-9 sm:py-3 xl:py-3 2xl:py-4 xxl:py-5 sm:px-9 xl:px-10 2xl:px-11 xxl:px-12 rounded-lg"
            >
              {loading2 ? <ClipLoader color="white" size={"1em"} /> : "Yes"}
            </button>
            <button
              type="button"
              onClick={handleConfirmSendBox}
              className="mt-4 bg-[#5D0E23] hover:bg-[#55051A] font-semibold sm:text-[11px] xl:text-[12px] 2xl:text-[13px] xxl:text-[14px] leading-none tracking-[-0.04em] text-center  cursor-pointer translate-all duration-400 text-white py-3 px-9 sm:py-3 xl:py-3 2xl:py-4 xxl:py-5 sm:px-9 xl:px-10 2xl:px-11 xxl:px-12 rounded-lg"
            >
              No
            </button>
          </div>
        </div>
      </div>
      {showReport ? (
        <div
          className="fixed top-0 z-[99] bg-[#292929A8] bg-opacity-90 w-screen h-screen flex items-start pt-8 sm:pt-12 xl:pt-16 pb-10 justify-center overflow-y-auto"
          onClick={closeReport}
        >
          <div
            role="dialog"
            aria-modal="true"
            aria-labelledby="recruiter-ai-report-title"
            className="bg-white text-[#5D0E23] w-[80%] px-2 sm:px-3 xl:px-4 py-1 sm:py-2 xl:py-2 rounded-[12px] shadow-lg relative max-h-[85vh] flex flex-col p-for-landscape"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center mb-[2px] sm:mb-1">
              <h2 id="recruiter-ai-report-title" className="font-semibold text-base sm:text-[18px] xl:text-[20px] 2xl:text-[22px] xxl:text-[24px] leading-none tracking-[0px]  bg-gradient-to-r from-[#3B4FF0] to-[#5D0E23] bg-clip-text text-transparent">
                AI Score Report
              </h2>
              <button type="button" aria-label="Close AI score report" onClick={closeReport}>
                <IoIosClose className="cursor-pointer" size={"2em"} color="#405e5d" />
              </button>
            </div>

            <div className="mb-2 space-y-1 border border-[#5D0E2312] p-1 sm:p-2 xl:p-2 rounded-[6px]  font-semibold text-sm sm:text-[13px] xl:text-[14px] 2xl:text-[15px] xxl:text-[16px] tracking-[0.01em]">
              <p>
                <span className="">Job Title:</span>{" "}
                <span className="font-normal">{aiJobTitle}</span>
              </p>
              <p>
                <span className="">Percentage:</span>{" "}
                <span className="font-normal">{formatAiScore(aiReport)}</span>
              </p>
            </div>

            <h2 className=" font-semibold text-base sm:text-[15px] xl:text-[16px] 2xl:text-[18px] xxl:text-[20px] tracking-[0.01em] sm:px-2 xl:px-2 text-[#86203B]">
              Details {aiReport?.error ? "(Report unavailable)" : null}
            </h2>

            <div className="mt-1 flex-1 space-y-1 overflow-y-auto sm:px-2 xl:px-2 scrollbar text-justify">
              {aiReport?.error ? (
                <p className="font-normal text-[#000000]">{aiReport.error}</p>
              ) : null}
              {aiReport?.parameters?.map((item, index) => (
                <div
                  key={index}
                  className=" font-semibold text-[10px] sm:text-[12px] xl:text-[14px] 2xl:text-[16px] tracking-[0.01em] text-[#86203B] pr-3 sm:pr-2 xl:pr-0"
                >
                  <p>
                    <span className="font-medium">Requirement:</span>{" "}
                    <span className="font-normal text-[#000000]">{item.requirement}</span>
                  </p>
                  <p>
                    <span className="font-medium">Analysis:</span>{" "}
                    <span className="font-normal text-[#000000]">{item.analysis}</span>
                  </p>
                  <p>
                    <span className="font-medium">Score:</span>
                    <span className="font-normal text-[#000000]">{item.score}%</span>
                  </p>
                </div>
              ))}
            </div>
            {aiReport?.error ? (
              <div className="flex flex-col items-end gap-1 px-2 pt-3">
                <button
                  type="button"
                  onClick={retryAiScore}
                  disabled={retryingAiScore || !selectedCandidateId}
                  className="min-w-[138px] rounded-md bg-[#86203B] px-4 py-2 text-sm font-semibold text-white hover:bg-[#5D0E23] disabled:cursor-not-allowed disabled:opacity-60"
                >
                  {retryingAiScore ? (
                    <ClipLoader color="white" size={"1em"} />
                  ) : (
                    "Retry AI Score"
                  )}
                </button>
              </div>
            ) : null}
          </div>
        </div>
      ) : null}

      <div className="sm:px-1 lg:px-0 sm:pr-0 xl:px-3 2xl:px-15 mt-[412px] sm:mt-[131px]  lg:mt-[131px] xl:mt-[155px] 2xl:mt-[176px]">
        <div className="fixed top-0 left-0 w-full z-50 bg-white px-3 sm:px-3 sm:pr-0 xl:pr-4 xl:px-4 2xl:px-15 py-1 sm:py-2 2xl:py-3">
          <header className="sm:pr-3 xl:pr-0">
            <Top currentUser={currentUser} />
            <Navbar currentUser={currentUser} batchTime={batchTime} syncStatus={syncStatus} />
          </header>
          <section className="px-3 pl-0 pr-0 sm:px-3 sm:pr-0 xl:px-0 mx-auto flex flex-col mt-1">
            {!loading && !loading2 && !loading3 ? <div className="overflow-x-auto  hide-scrollbar flex flex-col items-start sm:items-end sm:flex-row xl:flex-row gap-1 sm:gap-1 xl:gap-1 2xl:gap-1 mt-2">
              <div className="relative sm:mt-0 xl:mt-0 border-[0.5px] border-[#86203b] flex items-center rounded-[4px] pl-4 sm:pl-2 sm:pr-6 h-[29px] sm:h-[46px] w-full sm:min-w-[130px] xl:w-[200px] 2xl:w-[514px] mt-1 text-[12px]">
                <input
                  aria-label="Search candidates"
                  className="font-medium focus:border-0 placeholder-[#222222] focus:outline-0  w-full"
                  type="text"
                  value={searchValue}
                  onChange={handleSearch}
                  placeholder="Search Here.."
                />
                {searchValue ? <IoIosClose onClick={() => handleSearch2("")} size="2em" color="black" className="absolute top-1/2 -translate-y-1/2 right-1 cursor-pointer" /> : null}
              </div>

              <div className="text-[11px] pr-6  sm:px-1 xl:px-2 w-full sm:w-[200px] xl:w-[200px] 2xl:w-[306px] relative sm:static sm:flex-col xl:flex-col  font-sem-['Montserrat'] font-semibold leading-none tracking-[0px] rounded-[6px] border border-[#86203b] py-[8px] px-4 pl-3 text-white flex flex-row justify-between items-center sm:items-start xl:items-start gap-[6px] ">
                <label
                  className="-ml-[1px] whitespace-nowrap text-[#5D0E23]"
                  htmlFor="jobRole"
                >
                  Job Title
                </label>

                {showJobSelect && (
                  <div ref={jobTitleSRef} className="jobSelect w-[300px] max-h-[260px] sm:max-h-[482px] mt-[28px] overflow-y-scroll bg-white z-[999] absolute top-0 sm:top-auto flex flex-col border border-gray-400 shadow-lg">
                    <div className="relative">
                      <input
                        onChange={handelJobTitleSearch}
                        value={inputValue}
                        className="py-2 text-black focus:outline-none focus:border-none px-1 w-full pr-6"
                        type="text"
                        placeholder="Search"
                      />
                      {inputValue ? <IoIosClose onClick={() => handleJobTitleChange1("")} size="2em" color="black" className="absolute top-1/2 -translate-y-1/2 right-1 cursor-pointer" /> : null}
                    </div>
                    <p onClick={() => handleJobTitleChange("")} className={`text-black py-[8px] cursor-pointer ${jobTitle === "" ? "bg-[#1967D2] text-white" : "bg-white"} hover:bg-[#1967D2] hover:text-white px-1 `}>All</p>
                    {
                      (finalOptions.slice().sort((a, b) => a.jobTitle.localeCompare(b.jobTitle)).map((job, index) => (
                        <p
                          ref={job.jobTitle === jobTitle ? selectedJobRef : null}
                          onClick={() => handleJobTitleChange(job.jobTitle)}
                          className={`text-black py-[8px] ${job.jobTitle === jobTitle ? "bg-[#1967D2] text-white" : "bg-white"} cursor-pointer hover:bg-[#1967D2] hover:text-white px-1 `}
                          key={index}
                        >
                          {job.jobTitle}
                        </p>
                      )))
                    }
                  </div>
                )}

                <button type="button" ref={jobToggleRef} aria-label="Job title" aria-expanded={showJobSelect} onClick={() => setShowJobSelect((prev) => !prev)} className="cursor-pointer flex justify-between w-full select-none">
                  <p title={jobTitle || "All"} className="text-black whitespace-nowrap overflow-hidden">{jobTitle || "All"}</p>
                  <div className=" pointer-events-none bg-white pr-0">
                    <FaChevronDown
                      className="w-[14px] sm:w-[15px] xl:w-[16px] 2xl:w-[18px] xxl:w-[20px]"
                      color="#87213C"
                    />
                  </div>
                </button>
              </div>

              <div className="pr-6 relative sm:px-1 xl:px-2 w-full sm:w-[200px] xl:w-[200px] 2xl:w-[306px] xxl:w-[346px] sm:flex-col xl:flex-col  font-semibold text-[11px] leading-none tracking-[0px] rounded-[6px] border border-[#86203b] py-2 px-4 pl-3 text-white flex flex-row justify-between items-center sm:items-start xl:items-start gap-[6px] ">
                <label
                  className="-ml-[1px] whitespace-nowrap wordspace-nowrap text-[#5D0E23] sm:px-1"
                  htmlFor="jobRole"
                >
                  Job Code
                </label>
                <select
                  ref={selectRef1}
                  id="jobRole"
                  aria-label="Job code"
                  value={jobCode}
                  onChange={handleJobCodeChange}
                  className="focus:outline-0 appearance-none focus:border-0 w-full cursor-pointer text-[#000000] sm:px-1"
                >
                  <option value="">All</option>
                  {
                    jobTitle ? (
                      finalOptions
                        .filter((job) => job.jobTitle === jobTitle)
                        .slice()
                        .sort((a, b) => {
                          const numA = parseInt(a.jobCode.split('-')[1]?.trim(), 10);
                          const numB = parseInt(b.jobCode.split('-')[1]?.trim(), 10);
                          return numA - numB;
                        })


                        .map((job) => (
                          <option
                            ref={optionRef1}
                            key={job.id}
                            value={job.jobCode}
                            className="text-black"
                          >
                            {job.jobCode}
                          </option>
                        ))
                    ) : (
                      finalOptions
                        .slice()
                        .sort((a, b) => {
                          const numA = parseInt(a.jobCode.split('-')[1]?.trim(), 10);
                          const numB = parseInt(b.jobCode.split('-')[1]?.trim(), 10);
                          return numA - numB;
                        })


                        .map((job) => (
                          <option
                            key={job.id}
                            value={job.jobCode}
                            className="text-black"
                          >
                            {job.jobCode}
                          </option>
                        ))
                    )
                  }

                </select>
                <div className="absolute right-0 sm:top-[70%] xl:top-[70%] top-1/2 -translate-y-1/2 pointer-events-none bg-white pr-2">
                  <FaChevronDown
                    className="w-[14px] sm:w-[15px] xl:w-[16px] 2xl:w-[18px] xxl:w-[20px]"
                    color="#87213C"
                  />
                </div>
              </div>

              {/* <div className="pr-6 relative px-4 sm:px-1 xl:px-2 w-full sm:w-[200px] xl:w-[200px] 2xl:w-[306px] xxl:w-[346px] sm:flex-col xl:flex-col  font-semibold text-[11px] leading-none tracking-[0px] rounded-[6px] border border-[#86203b] py-2 pl-3 text-white flex flex-row justify-between items-center sm:items-start xl:items-start gap-[6px] ">
                <label
                  className="-ml-[1px] whitespace-nowrap wordspace-nowrap text-[#5D0E23] sm:px-1"
                  htmlFor="assessmentStatus"
                >
                  Job Type
                </label>
                <select
                  ref={selectRef3}
                  id="assessmentStatus"
                  onChange={handleJobTypeChange}
                  value={jobType}
                  className="focus:outline-0 appearance-none focus:border-0 w-full cursor-pointer text-[#000000] sm:px-1"
                >
                  <option selected value="active" className="text-black px-1">
                    Active
                  </option>
                  <option value="inactive" className="text-black">
                    Inactive
                  </option>
                </select>
                <div className="absolute right-0 sm:top-[70%] xl:top-[70%] top-1/2 -translate-y-1/2 pointer-events-none bg-white pr-2">
                  <FaChevronDown
                    className="w-[14px] sm:w-[15px] xl:w-[16px] 2xl:w-[18px] xxl:w-[20px]"
                    color="#87213C"
                  />
                </div>
              </div> */}
              <div className="pr-6 relative sm:px-1 xl:px-2 w-full sm:w-[200px] xl:w-[200px] 2xl:w-[306px] xxl:w-[346px] sm:flex-col xl:flex-col  font-semibold text-[11px] leading-none tracking-[0px] rounded-[6px] border border-[#86203b] py-2 px-4 pl-3 text-white flex flex-row justify-between items-center sm:items-start xl:items-start gap-[6px] ">
                <label
                  className="-ml-[1px] whitespace-nowrap wordspace-nowrap text-[#5D0E23] sm:px-1"
                  htmlFor="assessmentStatus"
                >
                  Qualification Status
                </label>
                <select
                  ref={selectRef4}
                  id="assessmentStatus"
                  aria-label="Qualification status"
                  onChange={handleJobStatusChange}
                  value={jobStatus}
                  className="focus:outline-0 appearance-none focus:border-0 w-full cursor-pointer text-[#000000] sm:px-1"
                >
                  <option value="">All</option>
                  <option value="qualified" className="text-black">
                    Qualified
                  </option>
                  <option value="unqualified" className="text-black">
                    Unqualified
                  </option>
                </select>
                <div className="absolute right-0 sm:top-[70%] xl:top-[70%] top-1/2 -translate-y-1/2 pointer-events-none bg-white pr-2">
                  <FaChevronDown
                    className="w-[14px] sm:w-[15px] xl:w-[16px] 2xl:w-[18px] xxl:w-[20px]"
                    color="#87213C"
                  />
                </div>
              </div>
              <div className="pr-6 relative sm:px-1 xl:px-2 w-full sm:w-[200px] xl:w-[200px] 2xl:w-[306px] xxl:w-[346px] sm:flex-col xl:flex-col  font-semibold text-[11px] leading-none tracking-[0px] rounded-[6px] border border-[#86203b] py-2 px-4 pl-3 text-white flex flex-row justify-between items-center sm:items-start xl:items-start gap-[6px] ">
                <label
                  className="-ml-[1px] whitespace-nowrap wordspace-nowrap text-[#5D0E23] sm:px-1"
                  htmlFor="assessmentStatus"
                >
                  Assessment Link
                </label>
                <select
                  ref={selectRef5}
                  id="assessmentStatus"
                  aria-label="Assessment link"
                  onChange={handleEmailStatusChange}
                  value={emailStatus}
                  className="focus:outline-0 appearance-none focus:border-0 w-full cursor-pointer text-[#000000] sm:px-1"
                >
                  <option value="">All</option>
                  <option value="sent" className="text-black">
                    Sent
                  </option>
                  <option value="not-sent" className="text-black">
                    Not Sent
                  </option>
                </select>
                <div className="absolute right-0 sm:top-[70%] xl:top-[70%] top-1/2 -translate-y-1/2 pointer-events-none bg-white pr-2">
                  <FaChevronDown
                    className="w-[14px] sm:w-[15px] xl:w-[16px] 2xl:w-[18px] xxl:w-[20px]"
                    color="#87213C"
                  />
                </div>
              </div>
              <div className="pr-6 relative sm:px-1 xl:px-2 min-w-[134px] w-full sm:w-[200px] xl:w-[200px] 2xl:w-[306px] xxl:w-[346px] sm:flex-col xl:flex-col  font-semibold text-[11px] leading-none tracking-[0px] rounded-[6px] border border-[#86203b] py-2 px-4 pl-3 text-white flex flex-row justify-between items-center sm:items-start xl:items-start gap-[6px] ">
                <label
                  className="-ml-[1px] whitespace-nowrap wordspace-nowrap text-[#5D0E23] sm:px-1"
                  htmlFor="assessmentStatus"
                >
                  Screening Status
                </label>
                <select
                  ref={selectRef6}
                  id="assessmentStatus"
                  aria-label="Screening status"
                  value={assessmentStatus}
                  onChange={handleAssessmentStatusChange}
                  className="focus:outline-0 appearance-none focus:border-0 w-full cursor-pointer text-[#000000] sm:px-1"
                >
                  <option value="">All</option>
                  <option value="assessed" className="text-black">
                    Assessed
                  </option>
                  <option value="not-assessed" className="text-black">
                    Not Assessed
                  </option>
                  <option value="hr-assessed" className="text-black">
                    HR Assessed
                  </option>
                </select>
                <div className="absolute right-0 sm:top-[70%] xl:top-[70%] top-1/2 -translate-y-1/2 pointer-events-none bg-white pr-2">
                  <FaChevronDown
                    className="w-[14px] sm:w-[15px] xl:w-[16px] 2xl:w-[18px] xxl:w-[20px]"
                    color="#87213C"
                  />
                </div>
              </div>
              <div className="pr-6 relative sm:px-2 xl:px-3 w-full sm:w-[200px] xl:w-[200px] 2xl:w-[306px] sm:flex-col xl:flex-col  font-sem-['Montserrat'] font-semibold text-[11px] leading-none tracking-[0px] rounded-[6px] border border-[#86203b] py-[10px] px-4 pl-3 text-white flex flex-row justify-between items-center sm:items-start xl:items-start gap-1 sm:gap-[2px]">
                <label
                  className="whitespace-nowrap text-[#5D0E23]"
                  htmlFor="jobRole"
                >
                  From
                </label>

                <div className="flex flex-col  text-black items-start">
                  <div className="flex gap-1 items-center ">
                    <p className="">{fromDate || "YYYY/MM/DD"}</p>
                    <input ref={fromDateRef} aria-label="From date" value={fromDate} onChange={handleFromDate} className="hide-date hidden-date-input" type="date" max={toDate || today} />
                    <SlCalender onClick={handleFromDateClick} size={"1em"} className="cursor-pointer " />
                  </div>
                </div>
              </div>
              <div className="pr-6 relative sm:px-2 xl:px-3 w-full sm:w-[200px] xl:w-[200px] 2xl:w-[306px] sm:flex-col xl:flex-col  font-sem-['Montserrat'] font-semibold text-[11px] leading-none tracking-[0px] rounded-[6px] border border-[#86203b] py-[10px] px-4 pl-3 text-white flex flex-row justify-between items-center sm:items-start xl:items-start gap-1 sm:gap-[2px]">
                <label
                  className="whitespace-nowrap text-[#5D0E23]"
                  htmlFor="jobRole"
                >
                  To
                </label>

                <div className="flex flex-col  text-black items-start">
                  <div className="flex gap-1 items-center ">
                    <p className="">{toDate || "YYYY/MM/DD"}</p>
                    <input ref={toDateRef} aria-label="To date" value={toDate} onChange={handleToDate} className="hide-date  hidden-date-input" type="date" max={today} min={fromDate} />
                    <SlCalender onClick={handleToDateClick} size={"1em"} className="cursor-pointer " />
                  </div>
                </div>
              </div>
              <div className="flex flex-row gap-1 sm:gap-1 xl:gap-1 2xl:gap-1">
                <button
                  disabled={loadingA || loadingC}
                  onClick={handleConfirmSendBox}
                  className="self-start sm:self-end font-semibold hover:bg-[#55051A] cursor-pointer text-[12px] leading-none tracking-[0px]  h-[30px] sm:h-[46px] w-[136px] px-2 bg-[#87213C] rounded-[6px] text-white whitespace-nowrap"
                >
                  {loadingA || loadingC ? (
                    <ClipLoader color="white" size={"1em"} />
                  ) : (
                    checkedCandidates.length > 0 ? "Send to Selected" : "Send to Qualified"
                  )}
                </button>
                <button
                  title="Clear Filters"
                  onClick={handleReset}
                  className="bg-[#87213C] text-[#ffffff] flex self-start sm:self-end p-[7px] sm:h-[46px] sm:min-w-[46px] sm:max-w-[46px] rounded-[6px] items-center justify-center cursor-pointer text-xs"
                >
                  Reset
                </button>
                <button
                  title="Run Batch"
                  disabled={batchStatus}
                  onClick={handleJobPostings}
                  className="bg-[#87213C] text-[#ffffff] flex self-start sm:self-end h-[30px] w-[30px]  sm:h-[46px] sm:min-w-[46px] sm:max-w-[46px] rounded-[6px] items-center justify-center cursor-pointer"
                >
                  {batchStatus || jobLoading ? <ClipLoader size={"1em"} color="white" /> : <IoReload size={"1.2em"} color="#ffffff" />}
                </button>

              </div>
            </div> : <div>
              <div className="flex flex-col space-x-4 sm:hidden">
                {Array(10).fill().map((_, i) => (
                  <Skeleton key={i} height={30} />
                ))}
              </div>
              <div className="space-x-4 overflow-hidden hidden sm:flex">
                {Array(18).fill().map((_, i) => (
                  <Skeleton key={i} height={46} width={100} />
                ))}
              </div>
            </div>}
          </section>
        </div>

        <section>
          <div className="mt-3 overflow-auto hide-scrollbar px-3 sm:px-4 pr-0 sm:pr-0 xl:px-0">
            <div className="relative">
              {/* Main scrollable container that holds both header and body */}
              <div className="table-div overflow-auto hide-scrollbar xl:scrollbar">
                <table className="border-collapse xl:w-full w-[1200px]">
                  <thead className="bg-[#87213C] text-white font-semibold text-[12px] leading-none tracking-[0px] px-10 sticky top-0 z-10">
                    <tr className="text-[10px] sm:text-[11px] xl:text-[12px] 2xl:text-[13px] xxl:text-[16px] font-semibold leading-none tracking-[0px] ">
                      <th className="whitespace-nowrap text-left px-4 pr-0 py-[3px] sm:py-1 xl:py-1 2xl:py-2 xxl:py-6 rounded-tl-[6px] rounded-bl-[6px]">
                        Name / <br /> Email
                      </th>
                      <th className="whitespace-nowrap text-left px-4 pr-0">
                        Job Title / <br /> Client Name
                      </th>
                      <th className="text-left px-4 pr-0">
                        <span className="whitespace-nowrap">JobCode /<br />Applicant ID</span>
                      </th>
                      <th className="text-left px-4 pr-0">
                        <span className="whitespace-nowrap">Resume / <br /> Phone no</span>
                      </th>
                      <th onClick={sortScores} className="whitespace-nowrap text-left px-4 pr-0 cursor-pointer select-none">
                        <div className="flex items-center gap-2">
                          <div>
                            PowerHires <br /> Scores
                          </div> {sortOrder === "desc" ? <FaLongArrowAltUp color={sortOn ? "#ffffff" : "#ffffff50"} /> : <FaLongArrowAltDown color={sortOn ? "#ffffff" : "#ffffff50"} />}
                        </div>
                      </th>
                      <th className="text-left px-4 pr-0">
                        Status
                      </th>
                      <th className="text-left whitespace-nowrap px-4 pr-0">
                        <div className=" flex items-center justify-between ">
                          Assessment <br /> links
                          <button type="button" aria-label="Select all candidates" aria-pressed={allChecked} onClick={() => handleAllCheck()} className="border border-[#ffffff] w-4 h-4 shrink-0 flex items-center justify-center cursor-pointer">
                            {
                              allChecked && <FaCheck color="#ffffff" size={"0.8em"} />
                            }
                          </button>
                        </div>
                      </th>
                      <th className="whitespace-nowrap text-left px-4 pr-0  rounded-tr-[6px] rounded-br-[6px]">
                        Email <br /> Sent Date
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading2 ? (
                      <tr>
                        <td colSpan="11" className={`text-start sm:text-center p-5`}>
                          <ClipLoader color="#9a3257" size={30} />
                        </td>
                      </tr>
                    ) : (
                      filteredCandidates.length < 1 ? <tr>
                        <td colSpan="11" className={`text-start sm:text-center p-5 ${loading2 ? "h-[440px]" : null}`}>
                          <h1 className="">No records found.</h1>
                        </td>
                      </tr> : filteredCandidates.map((candidate, index) => (
                        <tr
                          key={index}
                          data-candidate-id={candidate.candidate_id}
                          className={`text-[#000000] text-[11px] sm:text-[11px] xl:text-[12px] 2xl:text-[13px]   border-b border-[#EDEDED] bg-white hover:bg-[#F5F5F5] align-center font-medium leading-none tracking-[0px] `}
                        >
                          <td className={`px-4 pr-0 py-2 text-left`}>
                            <span className="text-[#000000] text-[11px] sm:text-[11px] xl:text-[12px] 2xl:text-[13px] font-normal  leading-none tracking-[0px] ">
                              {candidate?.name.trim() ? candidate.name : "NA"}
                            </span>
                            <br className="" />
                            <span className="block mt-[2px] text-[11px] sm:mt-[3px] xl:mt-[3px] 2xl:mt-[4px] font-medium text-[#000000] sm:text-[11px] xl:text-[12px] 2xl:text-[13px]">
                              {candidate.email}
                            </span>
                          </td>
                          <td className="px-4 pr-0 py-2 text-left">
                            <span className="text-[#000000] sm:text-[11px] xl:text-[12px] 2xl:text-[13px] font-normal  leading-none tracking-[0px] ">
                              {candidate.job_title}
                            </span>
                            <span className="block mt-[2px] sm:mt-[3px] xl:mt-[3px] 2xl:mt-[4px] font-medium text-[#000000]">
                              {candidate.client_name} { }
                            </span>
                          </td>
                          <td className="px-4 pr-0 py-2 text-left">
                            <span className="text-[#000000] font-normal text-[11px] sm:text-[11px] xl:text-[12px] 2xl:text-[13px] leading-none tracking-[0px] ">
                              {candidate.job_code}
                            </span>
                            <span className="block text-[11px] sm:text-[11px] xl:text-[12px] 2xl:text-[13px] mt-[2px] sm:mt-[3px] xl:mt-[3px] 2xl:mt-[4px] font-medium text-[#000000]">
                              {candidate.applicant_id}
                            </span>
                          </td>
                          <td className="px-4 pr-0 py-2 text-left">
                            <a
                              className={`cursor-pointer underline text-[#9a3257]`}
                              href={`${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/api/v1/resume/${encodeURIComponent(candidate.candidate_id)}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Resume
                            </a>
                            <br />
                            <span className="block mt-[2px] sm:mt-[3px] xl:mt-[3px] 2xl:mt-[4px] text-[#000000] font-normal leading-none tracking-[0px] ">
                              {candidate.phone_no}
                            </span>
                          </td>
                          <td className="px-4 pr-0 py-2 text-left whitespace-nowrap">
                            <button
                              type="button"
                              aria-label={`Open AI score report for ${candidate.name}`}
                              onClick={() =>
                                handleReport(
                                  candidate.ai_report,
                                  candidate.job_title,
                                  candidate.candidate_id
                                )
                              }
                              className="rounded-[8px] p-2 text-left w-fit underline text-[#3B4FF0] cursor-pointer"
                            >
                              {candidateScoreLabel(candidate)}
                            </button>
                          </td>
                          <td className="px-4 pr-0 py-2 text-left">
                            {(candidate.status || "N/A").charAt(0).toUpperCase() +
                              (candidate.status || "N/A").slice(1)}
                          </td>
                          <td className="px-4 pr-0 text-left flex items-center pt-4">
                            <div
                              className="text-[#3B4FF0]   w-full"
                            >
                              {loadingMap[candidate.candidate_id] || loadingA && candidate.status === "qualified" && candidate.assessment_score == null && candidate.hr_status !== "fail" || (loadingC && checkedCandidates.find((can) => can?.candidate_id === candidate?.candidate_id)) ? (
                                <div className="flex items-center justify-center w-[64%]">
                                  <ClipLoader color="#87213C" size={16} />
                                </div>
                              ) : (
                                <div className="flex gap-2 items-center justify-start w-full ">
                                  <button aria-label={`Send assessment to ${candidate.name}`} disabled={!canSendAssessment(candidate, activeJobsArr)} onClick={() =>
                                    sendSingleMail(
                                      candidate.name,
                                      candidate.applicant_id,
                                      candidate.candidate_id,
                                      candidate.email,
                                      candidate.phone_no
                                    )
                                  } className={`underline ${canSendAssessment(candidate, activeJobsArr) ? "cursor-pointer" : "text-[#6c757d]"}`}>Send
                                  </button>
                                  {candidate.email_status === "sent" || emailArray.includes(candidate.candidate_id) ? (
                                    <FaCheckCircle color="#9a3257" />
                                  ) : null}
                                  {candidate.assessment_score !== null ? (
                                    <p onClick={() => handleNavigate(candidate.candidate_id, true)}
                                      className="text-[11px] text-[#379744] cursor-pointer">Assessed</p>
                                  ) : null}
                                  {candidate.assessment_score === null && candidate.hr_status !== null ? (
                                    <p onClick={() => handleNavigate(candidate.candidate_id, false)}
                                      className={`text-[11px]  ${candidate.hr_status === "pass" ? "text-[#379744]" : "text-[#FF595C]"} cursor-pointer`}>HR</p>
                                  ) : null}
                                </div>
                              )}
                            </div>
                            {
                              canSendAssessment(candidate, activeJobsArr) && <button type="button" aria-label={`Select ${candidate.name}`} aria-pressed={Boolean(checkedCandidates.find((can) => can?.candidate_id === candidate?.candidate_id))} onClick={() => handleCheck(candidate, index)} className="border border-[#87213C] w-4 h-4 shrink-0 flex items-center justify-center cursor-pointer">
                                {
                                  checkedCandidates.find((can) => can?.candidate_id === candidate?.candidate_id) && <FaCheck color="#87213C" size={"0.8em"} />
                                }
                              </button>
                            }

                          </td>
                          <td
                            className="whitespace-nowrap px-4 pr-0 py-2 text-left"
                          >
                            {candidate.sent_time?.split("T")[0]}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
        <div className="absolute bottom-2 xl:right-4 text-[10px] sm:text-xs flex items-center justify-center sm:justify-end xl:justify-end text-center mt-2 font-semibold leading-none tracking-[0%]  w-full">
          <p className="pr-1 sm:pr-2 text-xs">Total {jobType ? `(${jobType?.slice(0, 1).toUpperCase() + jobType.slice(1)})` : ""}: {count}</p>
          <div className="border border-[#6563637c] text-[#000000] flex h-[30px] w-[94px] sm:w-[124px] rounded-[6px] items-center justify-center sm:gap-2 self-end">
            <p className="">Per Page</p>
            <select
              value={itemsPerPage}
              className="cursor-pointer focus:outline-none"
              onChange={(e) => handleItemPerPage(Number(e.target.value))}
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
          <button
            disabled={currentPage === 1}
            onClick={() => handlePageChange(currentPage - 1)}
            className={`sm:mx-1 px-1 sm:px-3 rounded-md ${currentPage === 1
              ? "text-[#CCCCCC] cursor-default"
              : "text-[#000000] cursor-pointer"
              }`}
          >
            Prev
          </button>

          {getPageNumbers().map((page, idx) => (
            <button
              key={idx}
              onClick={() => page !== "..." && handlePageChange(page)}
              className={`mx-1 ${page === "..." ? "cursor-default" : "cursor-pointer"} h-[18px] w-[18px] sm:h-[28px] sm:w-[28px]  rounded-md ${page === "..."
                ? "bg-white text-[#000000] cursor-default"
                : currentPage === page
                  ? "bg-[#5D0E23] text-white"
                  : "bg-white border text-[#000000] border-[#F1F1F1]"
                }`}
              disabled={page === "..."}
            >
              {page}
            </button>
          ))}

          <button
            disabled={currentPage === totalPages || count === 0}
            onClick={() => handlePageChange(currentPage + 1)}
            className={`sm:mx-1 px-1 sm:px-3 rounded-md  ${currentPage === totalPages || count === 0
              ? "text-[#cccccc] cursor-default"
              : "text-[#000000] cursor-pointer "
              }`}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default RecruiterDashboard;
